module.exports = __webpack_public_path__ + "media/images/logo_footer-3d036bd3f252665a33ab8057721628e4.svg";